// extracted by mini-css-extract-plugin
module.exports = {"is-mob":"eventPage_is-mob__ZjDUC","is-desk":"eventPage_is-desk__7x4wA","eventPage":"eventPage_eventPage__MNGNN","eventPage__content":"eventPage_eventPage__content__xdnvQ"};